import React from "react";
import ContentLoader from "react-content-loader";

export default function ChooseYourTicketLoading(props) {
  return (
    <ContentLoader
      speed={2}
      viewBox="0 0 390 300"
      backgroundColor="#f5f5f5"
      foregroundColor="#dbdbdb"
      {...props}
    >
      <rect x="10" y="0" rx="0" ry="0" width="6" height="265" />
      <rect x="10" y="0" rx="0" ry="0" width="380" height="5" />
      <rect x="385" y="0" rx="0" ry="0" width="6" height="265" />
      <rect x="10" y="260" rx="0" ry="0" width="380" height="5" />
      <rect x="150" y="30" rx="6" ry="6" width="120" height="15" />
      <rect x="50" y="60" rx="7" ry="7" width="300" height="140" />
      <rect x="50" y="220" rx="0" ry="0" width="300" height="8" />
      <rect x="50" y="238" rx="0" ry="0" width="270" height="8" />
    </ContentLoader>
  );
}
